import { render, staticRenderFns } from "./receive-records-modal.vue?vue&type=template&id=12dd7db6&"
import script from "./receive-records-modal.vue?vue&type=script&lang=js&"
export * from "./receive-records-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports